import React, { Suspense, useState } from "react";
import { Route, Routes } from "react-router-dom";
import Header from "../InitialPage/Sidebar/Header";
import Sidebar from "../InitialPage/Sidebar/Sidebar";
import { publicRoutes } from "./router.link";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import Scroll from "../utils/Scroll";
import { Spin } from "antd";
import ProtectedRoutes from "./ProtectedRoutes";

// Layout with header + sidebar
const HeaderLayout = () => {
  const data = useSelector((state) => state.toggle_header);
  const [showFilters, setShowFilters] = useState(false);
  return (
    <div className={`main-wrapper ${data ? "header-collapse" : ""}`}>
      <Header
        showFilters={showFilters}
        setShowFilters={setShowFilters}
      />
      <Sidebar />
      <Outlet context={{ showFilters, setShowFilters }} />
    </div>
  );
};

// Layout without header/sidebar (for login/reset pages)
const AuthLayout = () => (
  <div className="auth-wrapper">
    <Outlet />
  </div>
);

const AllRoutes = () => {
  const authPages = ["/sign-in", "/register", "/reset-password", "/forget-password"]; // 👈 yahan apni auth pages add karo

  return (
    <div>
      <Scroll />
      <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100wv', height: '100vh' }}><Spin size="large" /></div>}>
        <Routes>
          {/* Auth routes without header/sidebar */}
          {publicRoutes
            .filter((r) => authPages.includes(r.path))
            .map((route, id) => (
              <Route element={<AuthLayout />} key={id}>
                <Route path={route.path} element={route.element} />
              </Route>
            ))}

          {/* Normal routes with header/sidebar */}
          <Route element={<ProtectedRoutes />}>
            <Route element={<HeaderLayout />}>
              {publicRoutes
                .filter((r) => !authPages.includes(r.path))
                .map((route, id) => (
                  <Route path={route.path} element={route.element} key={id} />
                ))}
            </Route>
          </Route>
        </Routes>
      </Suspense>

    </div>
  );
};

export default AllRoutes;
